import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { SITE, NAV_LINKS } from "@/data/site";
import { SERVICES } from "@/data/services";

export default function Footer() {
  return (
    <footer className="bg-navy-950 text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-6 lg:py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center rounded-lg bg-white p-3" data-testid="footer-logo">
              <img src="/saivu-logo.png" alt="SAIVU — Saivu Consulting Pvt Ltd" className="h-12 w-auto object-contain" />
            </span>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-navy-100">
              {SITE.legalName} — a professional consulting company supporting businesses and
              individuals across finance, taxation, compliance, legal-support and advisory.
            </p>
            <div className="mt-6 flex flex-col gap-3 text-sm text-navy-100">
              <a href={`tel:${SITE.phoneTel}`} className="inline-flex items-center gap-2.5 hover:text-white" data-testid="footer-phone-link">
                <Phone className="h-4 w-4 text-gold" /> {SITE.phoneDisplay}
              </a>
              <a href={SITE.whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 hover:text-white" data-testid="footer-whatsapp-link">
                <MessageCircle className="h-4 w-4 text-gold" /> WhatsApp us
              </a>
              <a href={`mailto:${SITE.email}`} className="inline-flex items-center gap-2.5 hover:text-white" data-testid="footer-email-link">
                <Mail className="h-4 w-4 text-gold" /> {SITE.email}
              </a>
              <span className="inline-flex items-start gap-2.5" data-testid="footer-address">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> {SITE.address}
              </span>
            </div>
          </div>

          <div className="lg:col-span-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-gold">Services</p>
            <ul className="mt-5 grid grid-cols-1 gap-2.5 text-sm sm:grid-cols-2">
              {SERVICES.slice(0, 10).map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="text-navy-100 hover:text-white"
                    data-testid={`footer-service-link-${s.slug}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
              <li className="sm:col-span-2">
                <Link to="/services" className="font-medium text-gold hover:text-gold-soft" data-testid="footer-all-services-link">
                  View all 15 services →
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-gold">Company</p>
            <ul className="mt-5 flex flex-col gap-2.5 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-navy-100 hover:text-white" data-testid={`footer-nav-link-${l.label.toLowerCase()}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/privacy-policy" className="text-navy-100 hover:text-white" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-navy-800 pt-6 text-xs text-navy-100 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} {SITE.legalName}. All rights reserved.</p>
          <p className="font-mono uppercase tracking-[0.2em]">saivu.in</p>
        </div>
      </div>
    </footer>
  );
}
